import React, { useEffect, useState } from 'react';
import { clearClientStorageAndReload } from '../../utils/staleClientRecovery';
import './UpdatePrompt.css';

export default function UpdatePrompt() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const show = () => setVisible(true);
    window.addEventListener('smartnet:update-available', show);
    return () => window.removeEventListener('smartnet:update-available', show);
  }, []);

  if (!visible) return null;

  return (
    <div className="update-prompt" role="status" aria-live="polite">
      <div className="update-prompt__content">
        <p className="update-prompt__text">Hay una nueva versión disponible.</p>
        <button type="button" className="update-prompt__btn" onClick={() => void clearClientStorageAndReload()}>
          Actualizar ahora
        </button>
      </div>
    </div>
  );
}
